import { loadStripe } from '@stripe/stripe-js';

const { STRIPE_PUBLISHABLE_KEY, NODE_ENV } = process.env;
const stripeTestingKey = 'pk_test_TYooMQauvdEDq54NiTphI7jx';
const stripeKey = NODE_ENV === 'test' ? stripeTestingKey : STRIPE_PUBLISHABLE_KEY || ' ';

export default loadStripe(stripeKey);
